<template>
  <div class="section" :class="main_color">
    <div class="part part-approche">
      <div class="tle-row">
        <p class="label-small set-width" style="padding: 4px 0;"><span style="min-width: 180px;">Total Potentiel éligible au LLI : </span>
            <el-textarea
                :parent_data="active_study.etudeData.projet_urbain"
                property="potentiel_eligible"
                :editable="true"
                height='20px'
                overflow_edit='hidden scroll'
                placeholder="Préciser"
            />
        </p>
      </div>
      <div class="tle-row">
        <div class="comment">
          <el-textarea
            :parent_data="active_study.etudeData.projet_urbain"
            property="commentaire2"
            :editable="true"
            height='90px'
            overflow_edit='hidden scroll'
            placeholder="Préciser"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	name: "section-approche-quantitative",
	mixins: [PageMixin],
	data: function () {
		return {
		};
	},
	props: {
		main_color: { default: "dark_red" }
	},

	computed: {
		...mapGetters(["active_study", "editor"]),
	},
	methods: {
	},
	mounted: function () {
		if (!(this.active_study && this.active_study.etudeData && this.active_study.etudeData.projet_urbain && this.active_study.etudeData.projet_urbain.potentiel_eligible)) {
			this.$store.commit("SET_PROJET_URBAIN", {"index": "potentiel_eligible", "value": "Préciser"});
		}
		if (!(this.active_study && this.active_study.etudeData && this.active_study.etudeData.projet_urbain && this.active_study.etudeData.projet_urbain.commentaire2)) {
			this.$store.commit("SET_PROJET_URBAIN", {"index": "commentaire2", "value": "Commentaire CE/consultants"});
		}
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app'
@import '../../../../../assets/css/page'

ul
  list-style-type none !important

.td-cb
  min-width 120px
  width 60%

.td-price
  width 40%

.priorite
  text-align center
  line-height 1.5
  font-size 18px

  .input
    min-height @line-height * 1
    max-height @line-height * 1
</style>
<style lang="stylus">
.part-approche
  .comment
    width 100%
  .el-textarea
    width 100%
  .set-width
    display flex
    .el-textarea
      min-width 300px
</style>
